import Breadcrumb from 'components/Breadcrumb';
import React from 'react';
import generateBreadcrumbCategory from 'utils/generate_breadcrumb_name';

const BreadcrumbSection = (props) => {
  const { asPath, categoryName, parent, parentUrl } = props;
  let breadcrumbCategory = categoryName?.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase()).replace('+LMS', ' ').replace('Lerero & ', 'Lerero') || categoryName;
  return (
    <>
      {/* If show all product */}
      {asPath.includes('category?products=all') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Products', url: '/category?products=all', active: true },
          ]}
        />
      ) : null}

      {asPath.includes('category?bundles=all') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Bundles', url: '/category?bundles=all', active: true },
          ]}
        />
      ) : null}

      {asPath.includes('category?courses=all') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Courses', url: '/category?courses=all', active: true },
          ]}
        />
      ) : null}

      {/* if show all provider */}
      {asPath.includes('category?provider=all') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Providers', url: '/category?provider=all', active: true },
          ]}
        />
      ) : null}

      {/* if show all category */}
      {asPath.includes('?category=all') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Categories', url: '/category?category=all', active: true },
          ]}
        />
      ) : null}

      {/* if show one of provider */}
      {asPath.includes('?provider') && asPath.includes('name') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Providers', url: '/category?provider=all' },
            { title: generateBreadcrumbCategory(breadcrumbCategory), active: true },
          ]}
        />
      ) : null}

      {/* if show one of sub-category */}
      {asPath.includes('parent') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Categories', url: '/category?category=all' },
            {
              title: generateBreadcrumbCategory(parent),
              url: `/category?category=${encodeURIComponent(parentUrl)}`,
            },
            {
              title: generateBreadcrumbCategory(
                breadcrumbCategory === 'nutricition diet' || breadcrumbCategory === 'parenting relationship'
                  ? breadcrumbCategory.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase()).replace(' ', ' & ').replace('+LMS', ' ')
                  : breadcrumbCategory
              ),
              active: true,
            },
          ]}
        />
      ) : null}

      {/* if show search result */}
      {asPath.includes('/category?search=') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Search', active: true },
          ]}
        />
      ) : null}

      {/* if show one category */}
      {!asPath.includes('provider') &&
      !asPath.includes('category?products=all') &&
      !asPath.includes('category?bundles=all') &&
      !asPath.includes('?category=all') &&
      !asPath.includes('parent') &&
      !asPath.includes('?courses=all') &&
      !asPath.includes('/category?search=') ? (
        <Breadcrumb
          data={[
            { title: 'Home', url: '/' },
            { title: 'Category', url: '/category?category=all' },
            { title: generateBreadcrumbCategory(categoryName), active: true },
          ]}
        />
      ) : null}
    </>
  );
};

export default BreadcrumbSection;
